import { render, staticRenderFns } from "./yjzlInner.vue?vue&type=template&id=52950532&scoped=true"
import script from "./yjzlInner.vue?vue&type=script&lang=js"
export * from "./yjzlInner.vue?vue&type=script&lang=js"
import style0 from "./yjzlInner.vue?vue&type=style&index=0&id=52950532&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52950532",
  null
  
)

export default component.exports